<template>
    <div class="survey-results">
        <div v-for="[name, questions] in Object.entries(categories)" :key="name">
            <h4 class="survey-category-name">{{ name }}</h4>
            <SurveyCategory class="survey-category" :survey="survey" :questions="questions" />
        </div>
    </div>
</template>

<script>
import { SURVEY_CATEGORIES } from '@/pages/manage/ceo-change/Interviews/constants'
import SurveyCategory from '@/components/executives/Research/SurveyCategory.vue'

export default {
    components: { SurveyCategory },
    props: {
        survey: {
            type: Object,
            required: true,
        },
    },
    computed: {
        categories() {
            return SURVEY_CATEGORIES
        },
    },
}
</script>

<style>
.survey-results {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(540px, auto));
    grid-auto-rows: 1fr;
    gap: 40px;
}
</style>
